import zod from 'zod';

import {localize} from '@/shared/services/i18n';

const NAME_MAX_LENGTH = 100;
const EMAIL_MAX_LENGTH = 200;
const MESSAGE_MAX_LENGTH = 2000;

export type ContactFormValues = {
  name: string;
  email: string;
  message: string;
};

export function createContactSchema() {
  return zod.object({
    name: zod
      .string()
      .trim()
      .min(1, {message: localize('validations_name_required')})
      .max(NAME_MAX_LENGTH, {
        message: localize('validations_max_characters', {
          maxLength: NAME_MAX_LENGTH,
        }),
      }),
    email: zod
      .string()
      .trim()
      .min(1, {message: localize('email_request_code_title')})
      .max(EMAIL_MAX_LENGTH, {
        message: localize('validations_max_characters', {
          maxLength: EMAIL_MAX_LENGTH,
        }),
      })
      .email({message: localize('email_request_code_invalid_email')}),
    message: zod
      .string()
      .trim()
      .min(1, {message: localize('validations_contact_us_message')})
      .max(MESSAGE_MAX_LENGTH, {
        message: localize('validations_max_characters', {
          maxLength: MESSAGE_MAX_LENGTH,
        }),
      }),
  });
}
